import { render, staticRenderFns } from "./plotlyBody.vue?vue&type=template&id=08ff1233&"
import script from "./plotlyBody.vue?vue&type=script&lang=js&"
export * from "./plotlyBody.vue?vue&type=script&lang=js&"
import style0 from "./plotlyBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports